import 'core-js';

// Required for our Selenium tests as they use an ancient version of FF
global.ShadowRoot = global.ShadowRoot ?? new (class {})();

// Needed until we get Typescript more up to date
interface CaretPosition {
  offsetNode: Node;
  offset: number;
  getClientRect(): DOMRectReadOnly;
}

declare global {
  interface Document {
    caretPositionFromPoint(x: number, y: number, options?: { shadowRoots?: ShadowRoot[] }): CaretPosition | null;
  }
}
